// @ts-strict-ignore
import {Component, Input, output} from "@angular/core";
import {FormArray, FormControl} from "@angular/forms";
import {Mediaset} from "@models";
import {SimMediasetService} from "@services";
import {VMAutoCompleteNormal} from "../sim-base-chip-input/sim-base-chip-input.component";

@Component({
	selector: "sim-scenario-media-chip-input",
	templateUrl: "./sim-scenario-media-chip-input.component.html",
	styleUrls: ["./sim-scenario-media-chip-input.component.scss"],
	standalone: false,
})
export class SimScenarioMediaChipInputComponent {
	@Input() mediaSetFc: FormArray<FormControl<Mediaset>>;
	@Input() label: string;
	@Input() placeholder: string;

	@Input() canSelectMultipleMediaSets = false;

	optionSelected = output<Mediaset>();

	autoCompleteData: VMAutoCompleteNormal<Mediaset>[] = [];

	constructor(private _simMediaSetService: SimMediasetService) {}

	reloadAutoCompleteData(searchString: string) {
		this._simMediaSetService.listMediaSets(searchString, "Name", true, 0, 20).then((mediaSets) => {
			this.autoCompleteData = mediaSets.data.map((m) => ({
				displayName: m.name,
				value: m,
			}));
		});
	}
}
